module.exports = __webpack_public_path__ + "bin/d0f5e3438b7f0c87550212d38030119b.svg";